import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ManufacturerService } from '../../../services/manufacturer.service';


@Component({
  selector: 'app-manufacturer-picker',
  templateUrl: './manufacturer-picker.component.html',
  styleUrls: ['./manufacturer-picker.component.scss']
})
export class ManufacturerPickerComponent implements OnInit, OnChanges {
  @Input() manufacturerId: number;
  @Input() _placeholder: string = 'Please Select';
  @Output() onManufacturerIdSet = new EventEmitter<number>();
  @Output() onManufacturerSet = new EventEmitter<any>();

  manufacturers = [];


  constructor(public manufacturerService: ManufacturerService) {
  }

  ngOnInit(): void {
    this.manufacturerService.getAll().then((manufacturers) => {
      this.manufacturers = manufacturers;

      if (this.manufacturerId != undefined && this.manufacturerId != undefined) {
        var location = this.manufacturers.find(a => a.id == this.manufacturerId);
        this._placeholder = location.name;

      }
    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.manufacturerId != null && changes.manufacturerId.currentValue != null)) {
    
      if ((this.manufacturerId != undefined && this.manufacturerId != undefined)&&(this.manufacturers != undefined && this.manufacturers != undefined)) {
        var location = this.manufacturers.find(a => a.id == this.manufacturerId);
        this._placeholder = location.name;

      }
    
    }
  }

  onChanged(manufacturer) {
    if (manufacturer) {
      this.onManufacturerIdSet.emit(manufacturer.id);
      this.onManufacturerSet.emit(manufacturer);
    }

  }

}
